import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { FC, ReactElement, useState } from 'react';

export type MenuOption =
  | { kind: 'Button'; label: string | ReactElement; onClick: () => void; disabled?: boolean }
  | { kind: 'Link'; label: string | ReactElement; url: string; newTab?: boolean; disabled?: boolean };
const View: FC<{ options: MenuOption[] }> = ({ options }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const onClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const onClose = () => {
    setAnchorEl(null);
  };
  const style = { fontSize: '0.875rem' };

  return (
    <>
      <IconButton onClick={onClick}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={onClose}
      >
        {options.map((option, index) => {
          if (option.kind === 'Button') {
            return (
              <MenuItem
                key={index}
                onClick={() => {
                  option.onClick();
                  onClose();
                }}
                disabled={option.disabled}
                sx={style}
              >
                {option.label}
              </MenuItem>
            );
          } else {
            return (
              <MenuItem
                key={index}
                disabled={option.disabled}
                sx={style}
              >
                <a
                  className={''}
                  href={option.url}
                  rel="noreferrer"
                  target={option.newTab ? '_blank' : ''}
                >
                  {option.label}
                </a>
              </MenuItem>
            );
          }
        })}
      </Menu>
    </>
  );
};

export default View;
